export default __webpack_public_path__ + "static/media/reply-all-final.709e855c.svg";